import axios from "axios";
// import { createBrowserHistory } from "history";
// export const history = createBrowserHistory();

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  headers: { Pragma: "no-cache" },
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    switch (error.response.status) {
      case 403:
        if (
          error.response.config.url !== "contact/notifications" &&
          error.response.config.url !== "contact" &&
          !error.response.config.url.startsWith("alerts")
        ) {
          console.log(`Error 403 from: ${error.response.config.url}`);
          //   history.push("/unauthorized");
          //   history.go(0);
          return Promise.reject(error);
        }
        break;
      default:
        break;
    }

    return Promise.reject(error);
  }
);

export default instance;
